import { ThemeOptions } from "@mui/material";

const shape: ThemeOptions["shape"] = { borderRadius: 12 };

export default shape;
